import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { PostsType } from '../../../../../../types/posts';

export const CTAModalsMap = {
  [PostsType.JOURNALS]: ModalType.JOURNAL,
  featuredJournal: ModalType.JOURNAL,
  [PostsType.STATUSES]: ModalType.STATUS_UPDATE,
  [PostsType.POLLS]: ModalType.POLL_EDIT,
};
